import React from 'react';
import clsx from 'clsx';
import { Stack, Text, Fabric } from 'office-ui-fabric-react';
import styles from './Footer.style';
import { isMobileApp } from '../../utils';

const isMobile = isMobileApp();

const Footer = () => (
  <Fabric className={clsx(styles.root, isMobile && styles.mobile)}>
    {!isMobile && (
      <>
        <Stack
          horizontal
          horizontalAlign="space-around"
          className={styles.footer}
          data-testid="footer"
        >
          <Stack.Item>
            <Text>What&apos;s new</Text>
            <ul>
              <li>
                <a href="https://www.microsoft.com/en-us/surface">Surface Book 2</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/surface">Surface Pro</a>
              </li>
              <li>
                <a href="https://www.xbox.com/en-us/xbox-one-x">Xbox One X</a>
              </li>
              <li>
                <a href="https://www.xbox.com/en-us/xbox-one-s?xr=shellnav">Xbox One S</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/store/b/virtualreality">
                  VR & Mixed Reality
                </a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/windows/windows-10-apps">
                  Windows 10 apps
                </a>
              </li>
              <li>
                <a href="https://appsource.microsoft.com/en-us/marketplace/apps?product=office&page=1&src=office&corrid=547f04c0-dcfa-437b-a859-350d43cc0c3a&omexanonuid=bb25efad-4923-49b8-8cc3-e4c050a30d39&referralurl=https%3a%2f%2fwww.microsoft.com%2fen-us%2fstore%2fb%2fvirtualreality">
                  Office apps
                </a>
              </li>
            </ul>
          </Stack.Item>
          <Stack.Item>
            <Text>Store and Support</Text>
            <ul>
              <li>
                <a href="https://account.microsoft.com/account/Account?refd=www.microsoft.com&ru=https%3A%2F%2Faccount.microsoft.com%2F%3Frefd%3Dwww.microsoft.com&destrt=home-index">
                  Account Profile
                </a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/download">Download Center</a>
              </li>
              <li>
                <a href="https://support.microsoft.com/en-us/help/28808/microsoft-store-contact-support">
                  Sales and support
                </a>
              </li>
              <li>
                <a href="https://support.microsoft.com/en-us/hub/4135076/microsoft-store-help#returns-refunds">
                  Returns
                </a>
              </li>
              <li>
                <a href="https://login.live.com/login.srf?wa=wsignin1.0&rpsnv=13&ct=1545996665&rver=7.0.6738.0&wp=MBI_SSL&wreply=https%3A%2F%2Faccount.microsoft.com%2Fauth%2Fcomplete-signin%3Fru%3Dhttps%253A%252F%252Faccount.microsoft.com%252Fbilling%252Forders%253FforcedSignIn%253D1%2526refd%253Dwww.microsoft.com&lc=1033&id=292666&lw=1&fl=easi2">
                  Order tracking
                </a>
              </li>
              <li>
                <a href="https://support.microsoft.com/en-us">Support</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/store/b/buy-online-pick-up-in-store?icid=uhf_footer_bopuis">
                  Buy online pick up in store
                </a>
              </li>
            </ul>
          </Stack.Item>
          <Stack.Item>
            <Text>Education</Text>
            <ul>
              <li>
                <a href="https://www.microsoft.com/en-us/education">Microsoft in education</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/education/products/office/default.aspx">
                  Office for students
                </a>
              </li>
              <li>
                <a href="https://products.office.com/en-us/academic/compare-office-365-education-plans">
                  Office 365 for schools
                </a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/store/b/education?icid=CNavfooter_Studentsandeducation">
                  Deals for students & education
                </a>
              </li>
              <li>
                <a href="https://azure.microsoft.com/en-us/education/">
                  Microsoft Azure in education
                </a>
              </li>
            </ul>
          </Stack.Item>
          <Stack.Item>
            <Text>Enterprise</Text>
            <ul>
              <li>
                <a href="https://azure.microsoft.com/en-us/">Microsoft Azure</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/enterprise">Enterprise</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/sql-server/">Data platform</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/solution-providers/home">
                  Find a solution provider
                </a>
              </li>
              <li>
                <a href="https://partner.microsoft.com/en-us/">Microsoft partner resources</a>
              </li>
              <li>
                <a href="https://appsource.microsoft.com/en-US/">Microsoft AppSource</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/enterprise/manufacturing/discrete-manufacturing">
                  Manufacturing & Resources
                </a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/enterprise">Financial services</a>
              </li>
            </ul>
          </Stack.Item>
          <Stack.Item>
            <Text>Developer</Text>
            <ul>
              <li>
                <a href="https://visualstudio.microsoft.com/">Microsoft Visual Studio</a>
              </li>
              <li>
                <a href="https://developer.microsoft.com/en-us/windows">Windows Dev Center</a>
              </li>
              <li>
                <a href="https://msdn.microsoft.com/en-us">Developer Network</a>
              </li>
              <li>
                <a href="https://technet.microsoft.com/en-us">TechNet</a>
              </li>
              <li>
                <a href="https://mva.microsoft.com/">Microsoft Virtual Academy</a>
              </li>
              <li>
                <a href="https://developer.microsoft.com/en-us/store/register">
                  Microsoft developer program
                </a>
              </li>
              <li>
                <a href="https://channel9.msdn.com/">Channel 9</a>
              </li>
              <li>
                <a href="https://developer.microsoft.com/en-us/office">Office Dev Center</a>
              </li>
            </ul>
          </Stack.Item>
          <Stack.Item>
            <Text>Company</Text>
            <ul>
              <li>
                <a href="https://careers.microsoft.com/us/en">Careers</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/about">About Microsoft</a>
              </li>
              <li>
                <a href="https://news.microsoft.com/">Company news</a>
              </li>
              <li>
                <a href="https://privacy.microsoft.com/en-us">Privacy at Microsoft</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/investor">Investors</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/diversity/default.aspx">
                  Diversity and Inclusion
                </a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/accessibility">Accessibilty</a>
              </li>
              <li>
                <a href="https://www.microsoft.com/en-us/security">Security</a>
              </li>
            </ul>
          </Stack.Item>
        </Stack>

        <Stack horizontal horizontalAlign="space-around" className={styles.navFooter}>
          <Stack.Item>
            <a href="/">English (United States)</a>
          </Stack.Item>
          <Stack.Item>
            <a href="mailto:roybcdevteam@microsoft.com">Contact us</a>
          </Stack.Item>
          <Stack.Item>
            <a href="https://privacy.microsoft.com/en-US/privacystatement">
              Microsoft Privacy Statement
            </a>
          </Stack.Item>
          <Stack.Item>
            <a href="https://www.microsoft.com/en-us/legal/intellectualproperty/copyright/default.aspx">
              Terms of use
            </a>
          </Stack.Item>
          <Stack.Item>
            <a href="https://www.microsoft.com/en-us/legal/intellectualproperty/trademarks/en-us.aspx">
              Trademarks
            </a>
          </Stack.Item>
          <Stack.Item>
            <a href="https://account.microsoft.com/privacy/ad-settings/signedout?ru=https:%2F%2Faccount.microsoft.com%2Fprivacy%2Fad-settings">
              About our ads
            </a>
          </Stack.Item>
          <Stack.Item>
            <a href="/">&#x000A9; Microsoft 2020</a>
          </Stack.Item>
        </Stack>
      </>
    )}
  </Fabric>
);

export default Footer;
